import React from 'react'
import { useDispatch } from "react-redux";
import { SearchInput } from "../../widgets";
import { setScoutSearchText } from '../../../actions/scout-kanban';

const SearchBox = () => {
    const dispatch = useDispatch();
    return <SearchInput className="mt-1"
        placeholder="Search for Fields,Scouts"
        onChange={searchText => {
            dispatch(setScoutSearchText(searchText));
        }} />
}

export default SearchBox
